import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export function useDocuSign(c, initialTerms) {
  const [kind, setKind] = useState("loi");
  const [email, setEmail] = useState(c.email || "");
  const [name, setName] = useState((c.dirigeants && c.dirigeants[0]) || "");
  const [mode, setMode] = useState("email");
  const [sending, setSending] = useState(false);
  const [previewing, setPreviewing] = useState(false);
  const [rows, setRows] = useState([]);
  const [refreshing, setRefreshing] = useState("");
  const [showTerms, setShowTerms] = useState(false);
  const [terms, setTerms] = useState({ montant: "", exclusivite_jours: "", accompagnement_mois: "", clauses_extra: "" });
  const setT = (k, v) => setTerms((p) => ({ ...p, [k]: v }));

  const load = async () => {
    try { const { data } = await api.get(`/companies/${c.id}/docusign`); setRows(data || []); } catch (e) { console.debug("docusign load failed", e); /* ignore */ }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [c.id]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (initialTerms) {
      setKind("loi");
      setTerms((p) => ({ ...p, ...initialTerms }));
      setShowTerms(true);
    }
  }, [initialTerms]);

  const termsPayload = () => {
    const t = {};
    if (terms.montant) t.montant = Number(terms.montant);
    if (terms.exclusivite_jours) t.exclusivite_jours = Number(terms.exclusivite_jours);
    if (terms.accompagnement_mois) t.accompagnement_mois = Number(terms.accompagnement_mois);
    if ((terms.clauses_extra || "").trim()) t.clauses_extra = terms.clauses_extra;
    return t;
  };

  const preview = async () => {
    setPreviewing(true);
    try {
      const res = await api.post(`/companies/${c.id}/${kind}/preview`, { terms: termsPayload() }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch { toast.error("Erreur génération de l'aperçu"); } finally { setPreviewing(false); }
  };

  const send = async () => {
    if (!email.trim()) { toast.error("Email du signataire requis"); return; }
    setSending(true);
    try {
      const { data } = await api.post(`/companies/${c.id}/docusign/send`, {
        kind, signer_email: email.trim(), signer_name: name.trim(), mode, terms: termsPayload(),
      });
      toast.success(`${kind.toUpperCase()} envoyé pour signature à ${email}`);
      if (mode === "embedded" && data.signing_url) window.open(data.signing_url, "_blank");
      await load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur envoi DocuSign");
    } finally { setSending(false); }
  };

  const refresh = async (eid) => {
    setRefreshing(eid);
    try { const { data } = await api.get(`/docusign/envelopes/${eid}/refresh`); toast.success(`Statut : ${data.status_fr || data.status}`); await load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur rafraîchissement"); } finally { setRefreshing(""); }
  };

  return {
    kind, setKind, email, setEmail, name, setName, mode, setMode,
    sending, previewing, rows, refreshing, showTerms, setShowTerms,
    terms, setT, preview, send, refresh,
  };
}
